export default "__VITE_ASSET__C79$l7bf__"